import RecipeApp from './components/RecipeApp'

function App() {
  return <RecipeApp />
}

export default App